import { Construction } from 'lucide-react';

export const PlaceholderPage = ({ title, description }) => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] text-center">
      <Construction className="w-16 h-16 text-muted-foreground mb-4" />
      <h1 className="font-heading text-2xl font-bold mb-2">{title}</h1>
      <p className="text-muted-foreground max-w-md">
        {description || 'Este módulo está en desarrollo. Próximamente estará disponible.'}
      </p>
    </div>
  );
};

// Páginas específicas
export const ProveedoresPage = () => (
  <PlaceholderPage title="Proveedores" description="Gestión de proveedores de la empresa." />
);

export const CostoProyectoPage = () => (
  <PlaceholderPage title="Informe Costo por Proyecto" description="Análisis de costos agrupados por proyecto." />
);

export const CostoOTPage = () => (
  <PlaceholderPage title="Informe Costo por OT" description="Análisis de costos por Orden de Trabajo." />
);

export const ProformaFacturaPage = () => (
  <PlaceholderPage title="Proforma Factura" description="Generación de proformas de factura." />
);

export const MantencionFacturacionPage = () => (
  <PlaceholderPage title="Mantención Facturación" description="Gestión y mantención de facturación." />
);

export const GenerarOCPage = () => (
  <PlaceholderPage title="Generar Orden de Compra" description="Creación de nuevas órdenes de compra." />
);

export const ProveedoresComprasPage = () => (
  <PlaceholderPage title="Proveedores (Compras)" description="Gestión de proveedores para compras." />
);

export const SeguimientoOCPage = () => (
  <PlaceholderPage title="Seguimiento OC" description="Seguimiento de órdenes de compra activas." />
);

export const InventarioPage = () => (
  <PlaceholderPage title="Inventario" description="Control de inventario de bodega." />
);

export const TrabajadoresPage = () => (
  <PlaceholderPage title="Trabajadores" description="Gestión de trabajadores y personal." />
);
